import i18n from '~/i18n';
import { User } from '~/services/IdentityService';

export default function userDataToName(
    userData: Pick<User, 'firstName' | 'lastName'> | null,
    defaultName: string
) {
    if (!userData) return i18n.t(defaultName).toString();

    return userData.firstName && userData.lastName
        ? userData.firstName + ' ' + userData.lastName
        : userData.firstName
        ? userData.firstName
        : userData.lastName
        ? userData.lastName
        : i18n.t(defaultName).toString();
}
